import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { AviationEventTypeDesc, AviationEventType, TimeZones } from '../../shared/models/aviation-event.model';
import { MatDatepickerInputEvent, MatDialogRef, MatSnackBar } from '@angular/material';
import { AviationEventsService } from '../../shared/services/aviation-events.service';
import { eventAMPM, eventHours, eventMinutes } from '../../globals';
import * as MomentTZ from 'moment-timezone';
import { Router } from '@angular/router';
import { UserService } from '../../shared/user/user.service';
var CloneEventComponent = /** @class */ (function () {
    function CloneEventComponent(_matDialogRef, data, _aviationEventsService, _fb, _snackBar, _router, _userService) {
        this._matDialogRef = _matDialogRef;
        this._aviationEventsService = _aviationEventsService;
        this._fb = _fb;
        this._snackBar = _snackBar;
        this._router = _router;
        this._userService = _userService;
        this.isLoading = true;
        this.startDateMin = new Date();
        this.endDateMin = this.startDateMin;
        this.timeZones = Object.keys(TimeZones).sort();
        this.eventHours = eventHours;
        this.eventMinutes = eventMinutes;
        this.eventAMPM = eventAMPM;
        this.aviationEvent = data.aviationEvent;
    }
    CloneEventComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._matDialogRef.backdropClick().subscribe(function () {
            _this._matDialogRef.close(null);
        });
        this._userInfo = this._userService.userInfo.getValue();
        if (this._userInfo) {
            this.recId = Number(this._userInfo.masterCustomerId);
        }
        this._userService.userInfo.subscribe(function (u) {
            // Update userInfo
            _this._userInfo = u;
            if (u) {
                _this.recId = Number(u.masterCustomerId);
            }
        });
        var currentTimeZoneSimpleName = Object.keys(TimeZones).filter(function (it) { return TimeZones[it] === _this.aviationEvent.timezone; }).pop();
        this.eventTypes = Object.values(AviationEventTypeDesc);
        var currentEventType = AviationEventTypeDesc[AviationEventType[this.aviationEvent.typeId]];
        this.eventStart = MomentTZ.tz(this.aviationEvent.startDateTime, 'UTC');
        this.eventStartDateString = this.eventStart.clone().tz(this.aviationEvent.timezone).format('dddd, MMMM Do, YYYY');
        this.eventStartTimeString = this.eventStart.clone().tz(this.aviationEvent.timezone).format('HH:mm');
        this.eventEnd = MomentTZ.tz(this.aviationEvent.endDateTime, 'UTC');
        this.eventEndDateString = this.eventEnd.clone().tz(this.aviationEvent.timezone).format('dddd, MMMM Do, YYYY');
        this.eventEndTimeString = this.eventEnd.clone().tz(this.aviationEvent.timezone).format('HH:mm');
        this.startDate = this.eventStart.clone().tz(this.aviationEvent.timezone).toDate();
        this.endDate = this.eventEnd.clone().tz(this.aviationEvent.timezone).toDate();
        this.formGroup = this._fb.group({
            startDate: ['', Validators.required],
            endDate: ['', Validators.required],
            startHour: ['', Validators.required],
            startMin: ['', Validators.required],
            startAMPM: ['', Validators.required],
            endHour: ['', Validators.required],
            endMin: ['', Validators.required],
            endAMPM: ['', Validators.required],
            timezone: [currentTimeZoneSimpleName || '', Validators.required]
        }, { updateOn: 'submit' });
        this.isLoading = false;
    };
    CloneEventComponent.prototype.showDateError = function () {
        var startDate = this.formGroup.value.startDate;
        var endDate = this.formGroup.value.endDate;
        var startHour = +this.formGroup.value.startHour;
        startHour = this.formGroup.value.startAMPM === 'PM' ? startHour + 12 : startHour;
        var endHour = +this.formGroup.value.endHour;
        endHour = this.formGroup.value.endAMPM === 'PM' ? endHour + 12 : endHour;
        var dateBoolean = startDate && endDate && startDate.getTime() > endDate.getTime();
        if (startDate && endDate && startDate.getTime() === endDate.getTime()) {
            return startHour > endHour || (startHour === endHour && +this.formGroup.value.startMin > +this.formGroup.value.endMin);
        }
        return dateBoolean;
    };
    CloneEventComponent.prototype.eventDateChange = function (type, event) {
        var element = event.targetElement;
        if (element.getAttribute('name') === 'startDate') {
            this.endDateMin = event.value;
        }
    };
    CloneEventComponent.prototype.buildZonedTime = function (date, time, timezone) {
        var month = ('0' + (date.getMonth() + 1)).slice(-2);
        var day = ('0' + date.getDate()).slice(-2);
        var year = date.getFullYear();
        var localTime = MomentTZ.tz(year + "-" + month + "-" + day + " " + time, timezone);
        return localTime.utc().format('MM/DD/YYYY h:mm:ss A');
    };
    CloneEventComponent.prototype.close = function (result) {
        if (result === void 0) { result = { cancelBtnClicked: true, success: false }; }
        if (result) {
            this._matDialogRef.close(result);
        }
    };
    CloneEventComponent.prototype.cancel = function () {
        this._matDialogRef.close(null);
    };
    CloneEventComponent.prototype.save = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var TEMP_aviationEvent, tzName, startDate, startTime, endDate, endTime, cloneResponse, e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        TEMP_aviationEvent = this.aviationEvent;
                        tzName = TimeZones[this.formGroup.value.timezone];
                        startDate = new Date(this.formGroup.value.startDate);
                        startTime = +this.formGroup.value.startHour < 10 ? '0' + this.formGroup.value.startHour : this.formGroup.value.startHour;
                        // if startTime is 12:00 AM, set to 00:00
                        if (+this.formGroup.value.startHour === 12 && this.formGroup.value.startAMPM === 'AM') {
                            startTime = '00';
                        }
                        else {
                            startTime = this.formGroup.value.startAMPM === 'PM' && +this.formGroup.value.startHour < 12 ? (+startTime + 12).toString() :
                                startTime;
                        }
                        startTime = startTime + ':' + this.formGroup.value.startMin;
                        endDate = new Date(this.formGroup.value.endDate);
                        endTime = +this.formGroup.value.endHour < 10 ? '0' + this.formGroup.value.endHour : this.formGroup.value.endHour;
                        // if endTime is 12:00 AM, set to 00:00
                        if (+this.formGroup.value.endHour === 12 && this.formGroup.value.endAMPM === 'AM') {
                            endTime = '00';
                        }
                        else {
                            endTime = this.formGroup.value.endAMPM === 'PM' && +this.formGroup.value.endHour < 12 ? (+endTime + 12).toString() : endTime;
                        }
                        endTime = endTime + ':' + this.formGroup.value.endMin;
                        if (this.formGroup.invalid) {
                            this._snackBar.open('Form field validation failed. check form values', null, { duration: 5000 });
                            return [2 /*return*/];
                        }
                        else if (this.showDateError()) {
                            this._snackBar.open('Start time cannot be after end time, check end time is not before start time', null, { duration: 5000 });
                            return [2 /*return*/];
                        }
                        // this.aviationEvent.format = this.formGroup.value.format;
                        this.aviationEvent.timezone = tzName;
                        this.aviationEvent.startDateTimeUTC = this.buildZonedTime(startDate, startTime, tzName);
                        this.aviationEvent.endDateTimeUTC = this.buildZonedTime(endDate, endTime, tzName);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this._aviationEventsService.cloneAviationEvent(this.aviationEvent.eventId, this.aviationEvent.startDateTimeUTC, this.aviationEvent.endDateTimeUTC, this.recId)];
                    case 2:
                        cloneResponse = _a.sent();
                        this.close({ cancelBtnClicked: false, success: true });
                        this._router.navigate(['/event', cloneResponse.eventId]);
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        this.aviationEvent = TEMP_aviationEvent;
                        this.close({ cancelBtnClicked: false, success: false });
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    return CloneEventComponent;
}());
export { CloneEventComponent };
